<template>
  <div class="ingredient-item">
    <div class="ingredient-amount">
      {{amount}}
    </div>

    <div class="description">
      <div class="main-text">{{name}}</div>
      <div class="sub-text">{{subText}} </div>

      <div class="meta-text">
        <span class="badge badge-secondary" v-for="badge in badges">{{badge}}</span>
      </div>
    </div>

    <a :data-id="item.id"
       :data-type="type"
       v-if="editable"
       class="remove-item"
       @click.stop.prevent="removeIngredient">
      <BaseIcon name="delete"
                cssClass="ingredient-icon"
                title="Delete this item"
                width="24"
                height="24"/>
    </a>
  </div>
</template>

<script>
    export default {
        props: {
            item: Object,
            name:  String,
            amount: String,
            subText: String,
            type: String,
            editable: {
                type: Boolean,
                default: false
            },
            badges: Array,
            iconName: String,
            viewBox: {
                type: String,
                default: '0 0 24 24'
            },
        },
        components: {},
        data() { return {}; },

        methods: {
            removeIngredient: function (e) {
                this.$emit('delete-item', e)
            }
        },
        beforeMount() {},
    };
</script>

<style scoped lang="scss">
  @import "../../assets/scss/_variablesx.scss";

  $gray-base: lighten($gray-900, 15);


  .ingredient-item {
    padding: 1em 0;
    display: flex;
    flex-direction: row;
    position: relative;
    align-items: center;

    & > div { display: block; }

    ::v-deep svg {
      fill: $gray-base;
    }

    .ingredient-amount {
      text-align: center;
      line-height: 1;
      white-space: nowrap;
      font-size: 1.2em;
      scroll-padding-right: auto;
      margin-right: 0;
      margin-left: 0;
      color: $gray-base;
      width: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .description {
      padding-left: 1em;
      padding-right: 0;
      flex-grow: 3;
      flex-shrink: 3;

      .main-text {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 100%;
        width: 170px;
        flex-grow: 0;
      }

      .sub-text {
        font-size: .7em;
        margin-top: -0.2em;
        margin-bottom: 0.2em;
      }

      .meta-text {
        font-size: .8em;

        .badge {
          margin-right: .5em;
          opacity: .8;
        }
      }
    }

    .remove-item {
      flex-grow: 0;
      display: block;
      width: 25px;
      align-self: flex-start;
    }
  }


</style>
